import React from 'react';
import './About.css';
import BlockTitle from "../BlockTitle/BlockTitle";
import Marquee from "react-fast-marquee";
import videoBackground from "../../assets/video/Gradient Lite looped compressed.mp4";
import useAutoplayVideo from "../../hooks/useAutoplayVideo";

export default function About() {
    const videoRef = useAutoplayVideo();

    return <div className="about">
        <BlockTitle title={"о нас"} color="black"/>
        <div className="about-text">
            <video className="masked-video"
                   ref={videoRef}
                   data-src={videoBackground}
                   preload="none"
                   autoPlay loop
                   muted playsInline
            />

            <div className="about-text-div">
                — это опытная команда, которая сопровождает вас на всех этапах, от разработки стратегии до успешного запуска рекламных кампаний в сфере игр, стриминга и киберспорта
            </div>
        </div>
        <Marquee className="about-marquee" autoFill={true}>
            {["стримерам", "брендам", "блогерам", "киберспортсменам"].map(tag => <div
                className="about-tag"
            >
                <div className="about-tag-circle"/>
                <span>{tag}</span>
            </div>)}
        </Marquee>
    </div>
}
